import React from 'react';
// import '../../assets/css/event2503.css';
import '../../assets/css/event2512.css';

import { TopButton } from "../../components/TopButton"
import { Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';



export default function Event2512() {

    useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `동지 캠페인 | 어르신본죽왔어요`;
    },[]);

    // gsap.registerPlugin(useGSAP, ScrollTrigger);
    const container = useRef();

    useGSAP(() => {
    let tl01 = gsap.timeline({
        default:{duration: 0.1},
    }); // 인트로

    let tl02 = gsap.timeline({
      default:{duration: 0.3},
    }); // 인트로

    tl01.from('.motiona1', { opacity: 0, y: 100, })
        .from('.motiona2', { opacity: 0, y: 100, })
        .from('.motiona3', { opacity: 0, y: 100, })
        .from('.motiona4', { opacity: 0, y: 100, })

    gsap.to('.motiona6', { scale: 0.95, repeat: -1, yoyo: true, duration: 0.5, })

    tl02.fromTo('.nov-hoho01', { scale: 0 }, { opacity: 0,  scale: 1, y: -60, x:-20, duration: 1, repeat: -1 })
        .fromTo('.nov-hoho02', { scale: 0 }, { opacity: 0, scale: 1, y: -50, x:20, duration: 1.5, repeat: -1, })
        
    }, { scope: container });
    
    

    return (
        <article id='evnet-body' ref={container}>
            
            <TopButton />
    
            <section id='nov-top' className=''>
                <div id='nov-bg01' className='nov-inner section'>
                  
                  <div className='motiona1 mx300 pd-10'><img src={process.env.PUBLIC_URL + 'upload/2512/nov_title_01.png'} alt="" /></div>
                  <div className='motiona2 mx350 pd-10'><img src={process.env.PUBLIC_URL + 'upload/2512/nov_title_02.png'} alt="" /></div>
                  <div className='motiona3 mx350'>
                    <img src={process.env.PUBLIC_URL + 'upload/2507/nov_title_03.png'} alt="" />
                  </div>

                  <div className='img-people motiona4 hohodot'>
                    <div className='nov-hoho01'><img src={process.env.PUBLIC_URL + 'upload/2512/hoho_01.png'} alt="" /></div>
                    <div className='nov-hoho02'><img src={process.env.PUBLIC_URL + 'upload/2512/hoho_02.png'} alt="" /></div>
                    
                    <div className='img-box pd-10'>
                     <img src={process.env.PUBLIC_URL + 'upload/2512/nov_title_04.png'} alt="" />
                    </div>
                  </div>

                </div>

            </section>
    
            <section id='nov-about' className=''>
                <div id='nov-bg02' className='nov-inner'>
                  <div><img src={process.env.PUBLIC_URL + 'upload/2512/nov_event_02.jpg'} alt="" />
                  </div>
                </div>
            </section>
    
            <section id='nov-join' className=''>
                <div id='nov-bg02' className='nov-inner'>
                  <div className='dot'><img src={process.env.PUBLIC_URL + 'upload/2512/nov_event_03.jpg'} alt="" />
                  
                    <div className='nov-btn-join' id='btn-order-2512'>
                      <Link to="https://www.bonif.co.kr/order/type" target='_blank' rel="noopener noreferrer">
                        <img className='motiona6' src={process.env.PUBLIC_URL + 'upload/2512/btn_join.jpg'} alt="" />
                      </Link>
                    </div>

                    <div className='nov-btn-donation' id='btn-donation-2512'>
                      <Link to="https://naver.me/xdjxoJRJ" target='_blank' rel="noopener noreferrer">
                        <img className='motiona6' src={process.env.PUBLIC_URL + 'upload/2512/btn_donation.jpg'} alt="" />
                      </Link>
                    </div>
                  </div>
                </div>
            </section>
    

            <section id='nov-footer' className=''>
                <div id='nov-bg02' className='nov-inner'>

                  <div className='dot'>
                    <img src={process.env.PUBLIC_URL + 'upload/2512/nov_event_04.jpg'} alt="" />
                  
                  </div>
                </div>
            </section>
    

       </article>

    )
    
}